import { ISecurityQuestionsModalProps } from "./module/constants";

import { createStructuredSelector } from "reselect";

import { useState, useEffect } from "react";

import { Modal } from "react-bootstrap";

import classes from "./SecurityQuestionsModal.module.scss";
import messages from "./module/messages";
import { FormattedMessage } from "react-intl";

import { connect } from "react-redux";

import { ISecurityQuestion } from "../../../../pages/ProfileManagement/SecurityQuestionsManagement/module/constants";
import {
  getQuestionsLogin,
  postLoginAnswerAction,
  setUser,
} from "../../../../pages/Login/module/actions";
import {
  loginQuestionsLoaderSelector,
  loginQuestionsSelector,
  responseQuestionSelector,
  userLoginSelector,
} from "../../../../pages/Login/module/selectors";
import SecurityQuestionLogin from "../../../SecurityQuestion/SecurityQuestionLogin";
import {
  IDataPostLogin,
  IPostAnswer,
} from "../../../../pages/Login/module/constants";
import { IResponseState } from "../../ResponseModal/module/constants";
import CustomModal from "../../CustomModal/CustomModal";
import OutlinedButton from "../../../../ui/OutlinedButton/OutlinedButton";
import { CssTextField } from "../../../TextInputField/TextInputField";
import { IGrantType } from "../OTPModal/module/constants";
import Loader from "../../../Loader/Loader";

const SecurityQuestionsModal = (props: ISecurityQuestionsModalProps) => {
  const {
    user,
    questions,
    questionsLoader,
    modalQuestionState,
    getQuestions,
    setUserProp,
    sendAnswer,
    onConfirm,
  } = props;

  const [allowContinue, setAllowContinue] = useState(false);
  const [startQuestReq, setStartQuestReq] = useState(false);
  const [userCode, setUserCode] = useState("");
  const [okUser, setOkUser] = useState(false);
  const [showCustomModal, setShowCustomModal] = useState(false);

  useEffect(() => {
    setUserCode("");
    setOkUser(false);
  }, []);

  useEffect(() => {
    if (modalQuestionState === IResponseState.ERROR) {
      setShowCustomModal(true);
      getQuestions(userCode);
      setStartQuestReq(true);
    } else setShowCustomModal(false);
    if (modalQuestionState === IResponseState.SUCCESS) onConfirm();
    return () => setStartQuestReq(false);
  }, [modalQuestionState]);

  useEffect(() => {
    if (userCode !== "" && okUser) {
      getQuestions(userCode);
      setStartQuestReq(true);
      if (questions) {
      }
    }
    return () => setStartQuestReq(false);
  }, [user, okUser]);

  useEffect(() => {
    questions.map((q: ISecurityQuestion) => {
      if (q.answer !== "") {
        setAllowContinue(true);
      } else setAllowContinue(false);
    });
  }, [questions]);

  const handleUserFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (okUser) setOkUser(false);

    if (event.target) {
      const usr = event.target.value;
      setUserCode(usr);
    }
  };

  const handleSendAnswer = () => {
    let pass = [] as IPostAnswer[];
    questions.map((q) => pass.push({ id: q.id, answer: q.answer }));

    let body = {} as IDataPostLogin;
    body = {
      grant_type: IGrantType.SECURITYQUEST,
      username: userCode,
      password: pass, //encodedPass
      client_id: "10b56c3e-5e00-4bbc-b2c7-d9e0251c749a", //??
    };

    var formBody: any = [];
    Object.keys(body).forEach((key) => {
      let encodedKey, encodedValue;
      if (key !== "password") {
        encodedKey = encodeURIComponent(key);
        // @ts-ignore // ToDo -> fix types
        encodedValue = encodeURIComponent(body[key]);
      } else {
        encodedKey = encodeURIComponent(key);
        // @ts-ignore // ToDo -> fix types
        encodedValue = JSON.stringify(body[key]);
      }
      formBody.push(`${encodedKey}=${encodedValue}`);
    });
    formBody = formBody.join("&");

    sendAnswer(formBody);
  };

  return (
    <>
      <CustomModal
        size="sm"
        title={<FormattedMessage {...messages.errorAnswers} />}
        show={showCustomModal}
        onClose={() => setShowCustomModal(false)}
        message={<FormattedMessage {...messages.errorAnswersContent} />}
      />

      <Modal
        show={props.show}
        size={"lg"}
        onHide={props.onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            <FormattedMessage {...messages.SecurityQuestionsModalTitle} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <>
            <div className="row" style={{ rowGap: "1rem" }}>
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-center flex-wrap">
                <CssTextField
                  variant="filled"
                  fullWidth
                  type={"text"}
                  onChange={handleUserFieldChange}
                  value={userCode}
                  label={<FormattedMessage {...messages.UserCodeModalLabel} />}
                />
              </div>
              <div>
                <OutlinedButton onClick={() => setOkUser(true)}>
                  <FormattedMessage
                    {...messages.SecurityQuestionsModalConfirmUser}
                  />
                </OutlinedButton>
              </div>
            </div>
            <br />
          </>
          {!questionsLoader && questions.length !== 0 && (
            <FormattedMessage {...messages.SecurityQuestionsModalDesc} />
          )}

          {!questionsLoader &&
            questions.length !== 0 &&
            questions.map((question: ISecurityQuestion, i) => (
              <SecurityQuestionLogin
                key={question.id}
                securityQuestionBody={question.securityQuestion}
                securityQuestionKey={question.id}
                isSystemQuestion={question.defaultQuestion}
                isBeingAsked
                index={i}
                isLogin={true}
              />
            ))}
          {startQuestReq && !questionsLoader && questions.length === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontFamily: "mb",
              }}
            >
              <FormattedMessage {...messages.noQuestionsFound} />
            </div>
          )}
          {questionsLoader && (
            <div className={classes.loaderWrapper}>
              <Loader />
            </div>
          )}
          {!startQuestReq && <></>}
        </Modal.Body>

        <Modal.Footer className={classes.footer}>
          <button
            className={`${classes.btn} ${classes["btn-cancel"]}`}
            onClick={props.onClose}
          >
            <FormattedMessage {...messages.SecurityQuestionsModalClose} />
          </button>
          {questions.length !== 0 && (
            <button
              disabled={!allowContinue} //+ captcha?
              className={`${classes.btn} ${classes["btn-confirm"]}`}
              onClick={handleSendAnswer} //props.onConfirm
            >
              <FormattedMessage {...messages.SecurityQuestionsModalConfirm} />
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    questions: loginQuestionsSelector,
    questionsLoader: loginQuestionsLoaderSelector,
    user: userLoginSelector,
    modalQuestionState: responseQuestionSelector,
  });

/* DISPATCH ACTIONS */
const mapDispatchToProps: any = {
  getQuestions: (user: string) => getQuestionsLogin(user),
  setUserProp: (user: string) => setUser(user),
  sendAnswer: (payload: IDataPostLogin) => postLoginAnswerAction(payload),
};

//CONST CONNECT
const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(SecurityQuestionsModal);
